import script from "./AIChatAgentSetupLight.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatAgentSetupLight.vue?vue&type=script&setup=true&lang=js"

import "./AIChatAgentSetupLight.vue?vue&type=style&index=0&id=71c6b605&lang=css"
import "./AIChatAgentSetupLight.vue?vue&type=style&index=1&id=71c6b605&lang=css"

const __exports__ = script;

export default __exports__